import React from "react";
import { Link } from "react-router-dom";

import "./CreateItinButton.css"

export function CreateItinButton(props) {
    return <Link className="create-itin-button primary-button" to="/itin/create">
        Buat ITIN
    </Link>
}
